var map = {
	"./ManagementCosts.svg": "b0af",
	"./ProductionCycle.svg": "ab70",
	"./ProductionManagement.svg": "96df",
	"./and.svg": "1224",
	"./benefitingAll.svg": "c2ea",
	"./brand-value.svg": "73ef",
	"./business-fill.svg": "98f3",
	"./car.svg": "da43",
	"./choice-file.svg": "fe53",
	"./circleArrow-white.svg": "d454",
	"./circleArrow.svg": "e7ec",
	"./cms.svg": "3a8d",
	"./cooperation.svg": "c4df",
	"./customer-service.svg": "251a",
	"./customer.svg": "80a4",
	"./diploma.svg": "2dbb",
	"./email-fill.svg": "fde1",
	"./employee.svg": "a156",
	"./fax-fill.svg": "b134",
	"./fax.svg": "ba1f",
	"./fold.svg": "9a34",
	"./founding-date.svg": "0aae",
	"./giant.svg": "90f8",
	"./honesty.svg": "7139",
	"./internet.svg": "b4e6",
	"./iso.svg": "4952",
	"./language-dark.svg": "f5b3",
	"./language.svg": "1a11",
	"./left-wheat.svg": "ea4f",
	"./local-fill.svg": "544b",
	"./local.svg": "8d04",
	"./logo-dark.svg": "35ea",
	"./logo.svg": "ce80",
	"./marks.svg": "08b0",
	"./patent-star.svg": "fe0d",
	"./patent-wheat-left.svg": "5dd5",
	"./patent-wheat-right.svg": "e155",
	"./phone.svg": "51e0",
	"./player.svg": "a7ec",
	"./reselection.svg": "07d3",
	"./right-wheat.svg": "7ef4",
	"./star-banner.svg": "903d",
	"./star.svg": "3f55",
	"./target.svg": "aba3",
	"./teamwork.svg": "a1e3",
	"./technology-fill.svg": "094a",
	"./telephone-fill.svg": "1374",
	"./top-10.svg": "8673",
	"./tzmc.svg": "18dd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "79ff";